import { z } from 'zod'
import type { CarrierERPSettings } from '../../models/CarrierERPSettings'

export const CarrierERPSettingsDTO = z.object({
  enable_new_carriers_for_all_companies: z.boolean().nullish()
})

export type CarrierERPSettingsDTO = z.infer<typeof CarrierERPSettingsDTO>

export function mapCarrierERPSettingsToDTO (model: CarrierERPSettings): CarrierERPSettingsDTO {
  return {
    enable_new_carriers_for_all_companies: model.enableNewCarriersForAllCompanies
  }
}

export function mapDTOToCarrierERPSettings (dto: CarrierERPSettingsDTO): CarrierERPSettings {
  return {
    enableNewCarriersForAllCompanies: dto.enable_new_carriers_for_all_companies ?? false
  }
}
